import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

// This is the basic guard to check if the user has the correct permission to validate course attendance
export const ManageStaffGuard = () => {
  const authService = inject(AuthService)
  const router = inject(Router)
  let permissions: any;

  const authSubscription = authService.permissions$
    .subscribe((userPermissions: any) => {
      permissions = userPermissions
    })

  // Check if at least one of the required permissions has a value of 1
  if (permissions?.USER_ADD === 1 ||
    permissions?.USER_EDIT === 1 ||
    permissions?.MANAGE_PRIMARY_AUTHORITY === 1 ||
    permissions?.MANAGE_SECONDARY_AUTHORITY === 1 ||
    permissions?.MANAGE_ALL_AUTHORITY === 1 ||
    permissions?.USER_ACCOUNTS === 1
  ) {
    return true;
  }

  authSubscription.unsubscribe();
  return router.parseUrl('/dashboard')
}
